import * as React from 'react';
import { useEffect } from 'react';
import { Footer } from '../Components/Footer/Footer';
import { SearchBar } from '../Components/SearchBar/SearchBar';
import styled from 'styled-components';
import { useState } from 'react';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import useConstant from 'use-constant';
import { useAsync } from 'react-async-hook';
import { Database } from '../Managers/DataManager';
import { map, truncate } from 'lodash';
import { VideoTile } from '../Components/VideoShelf/VideoTile';
import { ImageAnimations } from '../Components/Image/Image';
import { Fade } from '@material-ui/core';


const Container = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start
justify-content: flex-start;
min-height: 100vh;

@media (min-width: 991px){
    margin-left: 80px;
    margin-right: 80px;
}

@media (max-width: 990px ){
    margin-left: 40px;
    margin-right: 40px;
}

@media(max-width: 767px){
    margin-right: 40px;
    margin-left: 40px;
}

@media(max-width: 480px){
    margin-right: 20px;
    margin-left: 20px;
}
`
 
const ResultsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap; 
    min-height: 70vh;
    min-width: 80vw;
    padding-bottom: 100px;
    flex: 1;
`

const MobileGroup = styled.div`
    @media (max-width: 534px){
        display: flex;
    }
`
const Margin = styled.div`
    margin-top: 1em;
    margin-bottom: 1em;
    margin-right: 0.5em; 
    width: calc((100vw - (160px + 4vw)) / 5);

    @media (max-width: 1799px){
        width: calc((100vw - (160px + 3vw)) / 4);
    }

    @media (max-width: 1279px){
        width: calc((100vw - (0.5em + 160px + 2vw)) / 3);
    }

    @media (max-width: 989px){
        width: 220px;
        flex: 1;
    }

    @media (max-width: 534px){
        width: 90vw;
    }

` 
const Title = styled.h3`
    font-size: 1em;
    font-weight: bold;
    color: white;

    @media (max-width: 534px){
       display: none;
    }
`
const SideTitle = styled.h3`
    font-size: 0.8em;
    font-weight: bold;
    color: white;
    margin-left: 1em;

    @media (min-width: 535px){
        display: none;
     }
`
const Desc = styled.p`
    color: rgba(200, 200, 200, 1);
    @media (max-width: 534px){
        font-size: 0.8em;
    }
`

const Message = styled.span`
    font-size: 3em;
    color: #CCCCCC;
    font-weight: bold;
`

const Center = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1
`

const useVideoSearch = () => useDebouncedSearch(text => Database.search(text))

export const Search = () => {



    const renderTile = (video) => {
        return(
            <Margin>
                <MobileGroup>
                    <VideoTile item={video} animation={ImageAnimations.scale}/>
                    <SideTitle>{video?.name}</SideTitle>
                </MobileGroup>
                <Title>{video?.name}</Title>
                <Desc>{truncate(video?.long_text, {'length': 150})}</Desc>
            </Margin>
        )
    }


    const {inputText: value, setInputText, searchResults} = useVideoSearch()
    const [ first, setFirst] = useState(false)
    useEffect(() => {
        if(!first && value != ""){
            setFirst(true)
        }
    }, [value])

    console.log(searchResults?.["result"])
    return(
        <div style={{
            paddingTop: 100,
            backgroundColor: '#04060a'
        }}> 
            <Container>
                <SearchBar 
                    value={value}
                    onChange={setInputText}
                    placeholder={"Search"} 
                    navigate={false}
                        />
                <Fade in={!searchResults?.["loading"] && first && (!searchResults?.["result"] || searchResults?.["result"]?.length === 0)} timeout={3000}>
                    <Center>
                        { !searchResults?.["loading"] && <Message>{searchResults?.["error"] ? searchResults?.["error"] : "No Search Results"}</Message>}
                    </Center>
                </Fade>
                <ResultsContainer>
                       
                        {map(searchResults?.["result"], video => <Margin key={video?.id}>{renderTile(video)}</Margin>)}
                     
                
                        
                </ResultsContainer>
            </Container>



            <Footer />


        </div>
    )
}


// Generic reusable hook
const useDebouncedSearch = (searchFunction) => {

    // Handle the input text state
    const [inputText, setInputText] = useState('');
  
    // Debounce the original search async function
    const debouncedSearchFunction = useConstant(() =>
      AwesomeDebouncePromise(searchFunction, 300)
    );
  
    const searchResults = useAsync(
      async () => {
        if (inputText.length === 0) {
          return [];
        } else {
          return debouncedSearchFunction(inputText);
        }
      },
      [debouncedSearchFunction, inputText]
    );
  
    // Return everything needed for the hook consumer
    return {
      inputText,
      setInputText,
      searchResults,
    };
  };